import React, { forwardRef, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import theme from 'style/theme';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ButtonBase from '@material-ui/core/ButtonBase';
import { useTranslation } from 'react-i18next';

type ToggleProps = { onClick: (e: React.MouseEvent<HTMLButtonElement>) => void; label: string };

const useStyles = makeStyles(() => ({
  button: {
    textAlign: 'left',
    paddingBottom: 0,
    marginBottom: 8,
    color: theme.colors.eastBay,
    fontWeight: 700,
    justifyContent: 'flex-start',
    '&:hover,&:focus': {
      color: theme.colors.eastBay,
    },
    '& span': {
      width: '100%',
    },
    '& h4': {
      textAlign: 'left',
      fontSize: 18,
      margin: 0,
      padding: 0,
    },
  },
}));

const CustomToggle = forwardRef<HTMLButtonElement, ToggleProps>(({ onClick, label }, ref) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <ButtonBase
      disableRipple
      className={classes.button}
      aria-describedby={label}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <h4>
        <span>{t(label)}</span>
      </h4>
      <ArrowDropDownIcon fontSize="large" />
    </ButtonBase>
  );
});

type SelectProps = {
  initialOptionIndex?: number;
  options: string[];
  onSelect: (e: string | null) => void;
};

const DropdownWithTextToggle = ({ options, onSelect, initialOptionIndex }: SelectProps) => {
  const { t } = useTranslation();
  const [label, setLabel] = useState(options[initialOptionIndex || 0]);

  useEffect(() => {
    if (!initialOptionIndex) return;
    setLabel(options[initialOptionIndex]);
  }, [initialOptionIndex, options]);

  const handleSelect = (eventKey: string | null) => {
    if (eventKey) {
      setLabel(eventKey || '');
      onSelect(eventKey);
    }
  };

  return (
    <Dropdown onSelect={handleSelect}>
      <Dropdown.Toggle as={CustomToggle} label={label}>
        Custom toggle
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option) => (
          <Dropdown.Item eventKey={option} key={option}>
            {t(option)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownWithTextToggle;
